import cx from 'classnames';
import s from './styles.scss';
import { Width } from '../../enums';

export interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  width?: Width;
}

export const Container = ({
  className,
  children,
  width = Width.DEFAULT,
}: ContainerProps): JSX.Element => (
  <div
    className={cx(className, s.container, {
      [s.narrow]: width === Width.NARROW,
      [s.default]: width === Width.DEFAULT,
      [s.wide]: width === Width.WIDE,
      [s.full]: width === Width.FULL,
    })}
  >
    {children}
  </div>
);
